<div class="preloader" v-if="preloader"></div>
<div :class="wrapperClassPrep" class="form-ii p-0" v-else>
    <input :checked="isChecked()" @change="changeToParent" v-bind="attributesPrep"/>
    <label :for="attributesPrep.id">
        <i class="icon check"></i>{{ label }} <Help v-if="helpText.length > 0" :text="helpText" class="ml-1" />
    </label>
</div>
